import { FC, useCallback, useState } from "react"
import { educationCategoryDeleteApi } from "src/domain/api/educationCategory/educationCategoryDeleteApi"
import { EducationCategory } from "src/domain/entities/educationCategory"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	educationCategory: EducationCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const EducationCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	educationCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleEducationCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await educationCategoryDeleteApi({ id: educationCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [educationCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete EducationCategory: ${educationCategory.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleEducationCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
